import { z } from "zod";

export const PaginationMetadataSchema = z.object({
  page: z.number().nonnegative(),
  perPage: z.number().nonnegative(),
  allCount: z.number().nonnegative(),
  pageCount: z.number().nonnegative(),
});

export const PaginationQuerySchema = z.object({
  page: z.number().int().positive().optional().default(1),
  perPage: z.number().int().positive().optional(),
});

export const makePaginatedSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    data: dataSchema.array(),
    metadata: PaginationMetadataSchema,
  });
